import { render, staticRenderFns } from "./iconInstagram.vue?vue&type=template&id=2f3e5882"
import script from "./iconInstagram.vue?vue&type=script&lang=js"
export * from "./iconInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports